export const environment = {
    production: false,
    country: "UY",
    APIEndpoint: 'https://apigatewaydemo.larifamos.com',
    translateUrl: "https://demo.larifamos.com",
    baseUrl: "https://demo.larifamos.com",
    domain: 'demo.larifamos.com',
    protocol: 'https',
    appName:"laRifamos",
    raffleSimulatorEnable: true,
    socialAuthRedirectUri: 'https://demo.larifamos.com/auth',
    oauthSocialEndpoint: 'https://apigateway.larifamos.com/social-oauth-service/oauth2/authorize',
    mercadoPago : { accessToken: 'TEST-7710988171901184-072018-c9ab2a1810b5074d3d101998c5ea287e-451443319',
                    publicKey: 'TEST-08d4f903-be22-448a-a15d-fed3db88c287',
                    urlApiV1: 'https://api.mercadopago.com/v1/'},
    subscription: { publicKey : 'BM3ia2Oss1NQ-znoRgn-DlpoHBEYsdudv1wm-LhAkEveX8pIIHfs5JAVw9LIjxZoBb7Ly333IAFph7H8RAbeKQ8'},
    userPaymentModesFeatureEnable: true,
    twitter: 'https://twitter.com/LaRifamos_uy',
    facebook: undefined,
    instagram: 'https://www.instagram.com/larifamos',
    youtube: 'https://www.youtube.com/@larifamos4914',
    bancardJs: undefined,
  validatePhone: false,
  fiservPaymentUi: 'https://caratgatewaytest.fiservapp.com/ui/services/payments/requestPayment',
  showUpcomingRafflesDetails: false,
  showRaffleQuantityTicketsAtHome: true
};
